import { FC, PropsWithChildren } from 'react'

import { Link } from '@remix-run/react'

import { IconMail, PrimaryButton } from '~/components'

type ContactCtaSectionProps = PropsWithChildren<{
  href: string
  isAvailable?: boolean
  className?: string
}>
export const ContactCtaSection: FC<ContactCtaSectionProps> = ({
  href,
  className,
  children,
  isAvailable = true,
}) => {
  return (
    <section className={className}>
      <div className="bg-cta-bg px-4 py-6 text-center">
        <div className="mb-4">
          <div className="mx-auto h-16 w-16 rounded-full bg-white p-3 text-cta">
            <IconMail />
          </div>
        </div>
        <div className="mb-4 text-body-bold">{children}</div>
        <Link rel="noreferrer" target="_blank" to={href}>
          <PrimaryButton
            className="mx-auto w-full max-w-[390px]"
            color="cta"
            outlined={!isAvailable}
          >
            {isAvailable ? 'お問い合わせ・内見予約' : '空き待ち予約する'}
          </PrimaryButton>
        </Link>
      </div>
    </section>
  )
}
